import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=66177aae&scoped=true&"
import script from "./CommentSection.vue?vue&type=script&lang=ts&"
export * from "./CommentSection.vue?vue&type=script&lang=ts&"
import style0 from "./CommentSection.vue?vue&type=style&index=0&id=66177aae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66177aae",
  null
  
)

export default component.exports